import React, { createContext, useContext, useState, useEffect ,useRef} from "react";
import Cookies from "js-cookie";

const IDLE_TIMEOUT = 30 * 60 * 1000; // 30 minutes

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const logoutTimerRef = useRef(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userId, setUserId] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkCookie = () => {
      const cookie = Cookies.get("isAuthenticated");
      const cookieExpiry = Cookies.get("authExpiry");
      const userId = Cookies.get("userId");

      if (cookie && cookieExpiry && userId) {
        const expiryDate = new Date(cookieExpiry);
        const now = new Date();

        if (now >= expiryDate) {
          logout();
        } else {
          setIsAuthenticated(true);
          setUserId(userId);
        }
      } else if (!cookie) {
        setIsAuthenticated(false);
        setUserId(null);
      }
      setIsLoading(false); // Mark loading as complete
    };
    checkCookie();
    const interval = setInterval(checkCookie, 3600000);

    return () => clearInterval(interval);
  }, []);

  const login = (userId) => {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 7);

    setIsAuthenticated(true);
    Cookies.set("isAuthenticated", true, { expires: 7 });
    Cookies.set("authExpiry", expiryDate.toISOString(), { expires: 7 });
    Cookies.set("userId", userId, { expires: 7 });
  };

  const logout = () => {
    setIsAuthenticated(false);
    Cookies.remove("isAuthenticated");
    Cookies.remove("authExpiry");
    window.location.href = "/login";

  };

  // console.log(isAuthenticated);
  const resetIdleTimer = () => {
    if (logoutTimerRef.current) {
      clearTimeout(logoutTimerRef.current);
    }

    logoutTimerRef.current = setTimeout(() => {
      logout();
    }, IDLE_TIMEOUT);
  };
  useEffect(() => {
    // Only start timer for logged-in users
    if (!isAuthenticated) {
      if (logoutTimerRef.current) {
        clearTimeout(logoutTimerRef.current);
      }
      return;
    }

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];

    events.forEach((event) => {
      window.addEventListener(event, resetIdleTimer);
    });

    // Start timer when user logs in
    resetIdleTimer();

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetIdleTimer);
      });

      if (logoutTimerRef.current) {
        clearTimeout(logoutTimerRef.current);
      }
    };
  }, [isAuthenticated]);
  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        userId,
        login,
        logout,
        isLoading,
        expiryDate: Cookies.get("authExpiry"),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
